import React, { useState } from 'react';
import * as S from './style';  // Reuse your slider styling, or adapt as needed
import { ImageViewer } from '..';
import { publicUrlStr } from '../../utils';

import { SwiperSlide } from 'swiper/react';
import { FreeMode, Navigation } from 'swiper/modules';
import 'swiper/css';           // core Swiper CSS
import 'swiper/css/navigation';// navigation module CSS

interface ILocalImage {
  id: number;
  title: string;
  source: string; // e.g. "apec1.jpg"
}

interface ImageSliderProps {
  title: React.ReactNode;
  images: ILocalImage[];
}

// A VideoSlider that opens VideoPlayer on click
function ImageSlider({ title, images }: ImageSliderProps) {
  // State to track which video is selected, if any
  const [selectedImage, setSelectedImage] = useState<ILocalImage | null>(null);

  // When a tile is clicked, set its file as selected
  const handleClick = (video: ILocalImage) => {
    setSelectedImage(video);
  };

  // Close the player by clearing selected video
  const handleClosePlayer = () => {
    setSelectedImage(null);
  };

  return (
    <S.SliderWrapper>
      <S.SliderTitle>{title}</S.SliderTitle>
      {/*Conditional: Check if the video list is empty*/}
      {images.length === 0 ? (
        <S.NoMediaMessage>Sorry! No content available for this category 😭</S.NoMediaMessage>
      ) : (
        <S.MySwiper
          modules={[Navigation, FreeMode]}
          navigation
          freeMode
          slidesPerView="auto" // show as many slides as will fit
          style={{ width: '97%' }}
          /*        
          // optional: you can set slidesPerView, spaceBetween, etc.
          slidesPerView={4} // how many slides to show at once (tweak as needed)
          spaceBetween={1}  // space between slides
          */
        >
          {images.map((img) => (
            <SwiperSlide key={img.id}>
              <S.VideoSliderItem onClick={() => handleClick(img)}>
                {/*Set thumbnail as background*/}
                <S.VideoTile videoThumbUrl={`${publicUrlStr()}/images/${img.source}`}/>
                <S.MediaTitle>{img.title}</S.MediaTitle>
              </S.VideoSliderItem>
            </SwiperSlide>
          ))}
        </S.MySwiper>
      )}

      {/* Conditionally render the VideoPlayer if a video is selected */}
      {selectedImage && (
        <ImageViewer
          imageSource={selectedImage.source}
          onClose={handleClosePlayer}
        />
      )}
    </S.SliderWrapper>
  );
}

export default ImageSlider;